import React from "react";
import leftArrow from "../../../assets/images/Icons/left_arrow.svg"
import rightArrow from "../../../assets/images/Icons/right_arrow.svg";

const ScrollArrows = ({ showLeftArrow, showRightArrow, scrollTabs }) => {
    return (
        <>
            {showLeftArrow && (
                <div className="arrow_btns">
                    <div className="arrow_btn left_arrow_btn" onClick={() => scrollTabs("left")}>
                        <img src={leftArrow} alt="Left Arrow" />
                    </div>
                </div>
            )}
            {showRightArrow && (
                <div className="arrow_btns">
                    <div className="arrow_btn right_arrow_btn" onClick={() => scrollTabs("right")}>
                        <img src={rightArrow} alt="Right Arrow" />
                    </div>
                </div>
            )}
        </>
    );
};

export default ScrollArrows;
